/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// =============================================================================
// Badge de status do cliente. Espelha o padrão StatusPill do módulo Routing
// (ItemStatusBadge) — verde para ativo, vermelho para inativo.
// =============================================================================

const StatusPill = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 4px 10px;
   border-radius: 999px;
   font-size: 11px;
   font-weight: 800;
   border: 1px solid ${({ $color }) => $color ?? 'rgba(0,0,0,0.15)'};
   background: ${({ $bg }) => $bg ?? 'rgba(0,0,0,0.06)'};
   color: ${({ $text }) => $text ?? '#444'};
   white-space: nowrap;
`;

const STATUS_CONFIG = {
   active: {
      label: 'Ativo',
      bg: 'rgba(46,125,50,0.12)',
      border: 'rgba(46,125,50,0.35)',
      text: '#1b5e20',
   },
   inactive: {
      label: 'Inativo',
      bg: 'rgba(211,47,47,0.12)',
      border: 'rgba(211,47,47,0.35)',
      text: '#b71c1c',
   },
};

export default function ClienteStatusBadge({ value }) {
   const cfg = STATUS_CONFIG[value] ?? {
      label: value ?? '—',
      bg: null,
      border: null,
      text: null,
   };

   return (
      <StatusPill $bg={cfg.bg} $color={cfg.border} $text={cfg.text}>
         {cfg.label}
      </StatusPill>
   );
}

ClienteStatusBadge.propTypes = {
   value: PropTypes.oneOf(['active', 'inactive']),
};
